import type { FormValues } from './types.js';

export const isCustomerInformationComplete = (
  values: Pick<
    FormValues,
    'certificateIssuedTo' | 'customerAddress' | 'countryCode' | 'policyYear'
  >,
): boolean =>
  Boolean(
    values.certificateIssuedTo && values.customerAddress && values.countryCode && values.policyYear,
  );
